var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldenCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 14 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41675 5.66667C1.41675 3.71066 3.00241 2.125 4.95842 2.125H12.0417C13.9978 2.125 15.5834 3.71066 15.5834 5.66667V12.0417C15.5834 13.9977 13.9978 15.5833 12.0417 15.5833H4.95842C3.00241 15.5833 1.41675 13.9977 1.41675 12.0417V5.66667ZM4.95842 3.54167C3.78481 3.54167 2.83341 4.49306 2.83341 5.66667V12.0417C2.83341 13.2153 3.78481 14.1667 4.95842 14.1667H12.0417C13.2154 14.1667 14.1667 13.2153 14.1667 12.0417V5.66667C14.1667 4.49306 13.2154 3.54167 12.0417 3.54167H4.95842Z",
    fill: "#D39E36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66659 1.41602C6.05779 1.41602 6.37492 1.73315 6.37492 2.12435V4.24935C6.37492 4.64055 6.05779 4.95768 5.66659 4.95768C5.27538 4.95768 4.95825 4.64055 4.95825 4.24935V2.12435C4.95825 1.73315 5.27538 1.41602 5.66659 1.41602Z",
    fill: "#D39E36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 7.08333C4.25 6.69213 4.56713 6.375 4.95833 6.375H12.0417C12.4329 6.375 12.75 6.69213 12.75 7.08333C12.75 7.47453 12.4329 7.79167 12.0417 7.79167H4.95833C4.56713 7.79167 4.25 7.47453 4.25 7.08333Z",
    fill: "#D39E36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 12.0423C10.625 11.6511 10.9421 11.334 11.3333 11.334L12.0417 11.334C12.4329 11.334 12.75 11.6511 12.75 12.0423C12.75 12.4335 12.4329 12.7507 12.0417 12.7507H11.3333C10.9421 12.7507 10.625 12.4335 10.625 12.0423Z",
    fill: "#D39E36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 1.41602C11.7245 1.41602 12.0417 1.73315 12.0417 2.12435V4.24935C12.0417 4.64055 11.7245 4.95768 11.3333 4.95768C10.9421 4.95768 10.625 4.64055 10.625 4.24935V2.12435C10.625 1.73315 10.9421 1.41602 11.3333 1.41602Z",
    fill: "#D39E36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenCalendar);
export default __webpack_public_path__ + "static/media/golden_calendar.cfd1cb5f01df68afd38cd48af98277d1.svg";
export { ForwardRef as ReactComponent };